import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  /* CSS Değişkenleri public/theme.css dosyasından yönetilmektedir */
  :root {
    /* Varsayılan değerler theme.css yüklenmezse diye buradadır, 
       ancak theme.css bunları ezecektir (eğer doğru yüklendiyse) */
  }

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    overflow-x: hidden;
    scroll-behavior: smooth;
  }

  body {
    background: linear-gradient(135deg, var(--background-start), var(--background-mid), var(--background-end));
    background-size: 100% 100%;
    background-attachment: fixed;

    color: var(--primary-color);
    font-family: 'Poppins', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }



  a {
    color: inherit;
    text-decoration: none;
  }

  ::-webkit-scrollbar {
    width: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #000;
  }
  ::-webkit-scrollbar-thumb {
    background: linear-gradient(var(--gradient-purple), var(--gradient-pink));
    border-radius: 10px;
  }
`;
